module.exports = __webpack_public_path__ + "static/05_rachel_caldwell-7cf5189fec031343de84d02b5dc1ee3a.jpg";